module.exports = __webpack_public_path__ + "static/media/stade_olympique.6b7ca211.jpg";